module.exports = __webpack_public_path__ + "static/media/okIcon.414f5ece.svg";